// src/components/providers/compare-adaptex-context.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { createContext } from "react";
// src/components/providers/compare-adaptex-arms.ts
var SHOW_PROMPT = "show-prompt";
var TOGGLE_PLACEMENT = "toggle-placement";
var TICK_BOX_VISIBILITY = "tick-box-visibility";
var SHOW_PROMPT_YES = "yes";
var SHOW_PROMPT_NO = "no";
var TOGGLE_PLACEMENT_NONE = "none";
var TOGGLE_PLACEMENT_FILTERS_SHEET = "filter-sheet";
var TOGGLE_PLACEMENT_SRP = "srp";
var TICK_BOX_VISIBILITY_TRUE = "true";
var TICK_BOX_VISIBILITY_FALSE = "false";
var _obj;
// src/components/providers/compare-adaptex-context.ts
var defaultState = {
    campaignId: "",
    payloadId: "",
    arms: (_obj = {}, _define_property(_obj, SHOW_PROMPT, SHOW_PROMPT_NO), _define_property(_obj, TOGGLE_PLACEMENT, TOGGLE_PLACEMENT_NONE), _define_property(_obj, TICK_BOX_VISIBILITY, TICK_BOX_VISIBILITY_FALSE), _obj),
    enabled: false,
    propertySearchCriteria: void 0,
    bottomSheetHeight: 0
};
var defaultValue = [
    defaultState,
    function() {
        return void 0;
    }
];
var CompareAdaptExContext = createContext(defaultValue);
// src/components/providers/compare-adaptex-provider.tsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useExperiment } from "@shared-ui/experiment-context";
var Provider = CompareAdaptExContext.Provider;
var CompareAdaptExProvider = function(param) {
    var propertySearchCriteria = param.propertySearchCriteria, children = param.children;
    var bucket = useExperiment("M1_Web_SDUI_Property_Comparison_Tool_MVP_on_SRP").exposure.bucket;
    var _useState = _sliced_to_array(useState(function() {
        var toggleState = typeof localStorage === "undefined" ? /* istanbul ignore next -- @preserve */ null : localStorage.getItem("toggleState");
        return _object_spread_props(_object_spread({}, defaultState), {
            propertySearchCriteria: propertySearchCriteria,
            enabled: toggleState ? toggleState === String(true) : bucket === 1
        });
    }), 2), state = _useState[0], setState = _useState[1];
    var enabled = state.enabled;
    useEffect(function() {
        localStorage.setItem("toggleState", String(enabled));
    }, [
        enabled
    ]);
    var value = useMemo(function() {
        return [
            state,
            setState
        ];
    }, [
        state,
        setState
    ]);
    var previousPropertySearchCriteria = useRef(propertySearchCriteria);
    if (propertySearchCriteria !== previousPropertySearchCriteria.current) {
        setState(function(currentState) {
            return _object_spread_props(_object_spread({}, currentState), {
                propertySearchCriteria: propertySearchCriteria
            });
        });
        previousPropertySearchCriteria.current = propertySearchCriteria;
        return null;
    }
    return /* @__PURE__ */ React.createElement(Provider, {
        value: value
    }, children);
};
// src/components/providers/lodging-compare-provider.tsx
import React2, { createContext as createContext2, useContext, useMemo as useMemo3 } from "react";
import { useLocation } from "react-router-dom";
// src/constants.ts
var DIALOG_KEY = "compareDialog";
var DIALOG_ID = "lodging-compare-dialog";
var COMPARE_PROPERTY_IDS_QUERY_PARAMETER = "comparePropertyIds";
// src/hooks/use-reducers.ts
import { useCallback, useMemo as useMemo2, useReducer } from "react";
var useReducers = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var initialState2 = useMemo2(function() {
        return args.length === 3 ? args[1](args[0]) : args[0];
    }, []);
    var reducers = args.length === 3 ? args[2] : args[1];
    var reducer = useCallback(function(state2, action) {
        var _reducers_action_type;
        var _reducers_action_type1;
        return (_reducers_action_type1 = (_reducers_action_type = reducers[action.type]) === null || _reducers_action_type === void 0 ? void 0 : _reducers_action_type.call(reducers, state2, action.payload)) !== null && _reducers_action_type1 !== void 0 ? _reducers_action_type1 : state2;
    }, []);
    var _useReducer = _sliced_to_array(useReducer(reducer, initialState2), 2), state = _useReducer[0], dispatch = _useReducer[1];
    var dispatchers = Object.fromEntries(Object.entries(reducers).map(function(param) {
        var _param = _sliced_to_array(param, 1), type = _param[0];
        return [
            type,
            function(payload) {
                return dispatch({
                    type: type,
                    payload: payload
                });
            }
        ];
    }));
    return [
        state,
        dispatchers
    ];
};
// src/utilities.ts
var isAd = function(mediaSection) {
    var _mediaSection_badges_secondaryBadge, _mediaSection_badges;
    return ((_mediaSection_badges = mediaSection.badges) === null || _mediaSection_badges === void 0 ? void 0 : (_mediaSection_badges_secondaryBadge = _mediaSection_badges.secondaryBadge) === null || _mediaSection_badges_secondaryBadge === void 0 ? void 0 : _mediaSection_badges_secondaryBadge.theme) === "sponsored";
};
var getPropertyIdFromCardId = function(cardId) {
    return cardId.split("-")[0];
};
var parsePropertyIds = function(parameter) {
    return (parameter !== null && parameter !== void 0 ? parameter : "").split(",").filter(function(param) {
        var length = param.length;
        return length !== 0;
    });
};
// src/components/providers/lodging-compare-provider.tsx
var getCardId = function(param) {
    var id = param.id, mediaSection = param.mediaSection;
    return isAd(mediaSection) ? "".concat(id, "-ad") : id;
};
var selectPropertyIds = function(propertyIds, searchResultsProperties) {
    return _to_consumable_array(new Set(propertyIds.filter(function(id) {
        return searchResultsProperties.some(function(card) {
            return id === getCardId(card);
        });
    })));
};
var preserveSelectedProperties = function(propertyIds, searchResultsProperties) {
    return propertyIds.map(function(selectedId) {
        return searchResultsProperties.find(function(card) {
            return getCardId(card) === selectedId;
        });
    }).filter(function(maybeCard) {
        return Boolean(maybeCard);
    });
};
var initialState = {
    searchResultsProperties: [],
    comparePropertyIds: [],
    isDialogOpen: false,
    reselectPropertyIds: null,
    deepLinkDialogPropertyIds: null,
    enabled: false,
    maxSelectable: 5,
    preservedProperties: [],
    bottomSheetHeight: 0
};
var setProperties = function(state, searchResultsProperties) {
    var reselectPropertyIds = state.reselectPropertyIds, comparePropertyIds = state.comparePropertyIds, previousSearchResults = state.searchResultsProperties, previousPreservedProperties = state.preservedProperties;
    var preservedProperties = preserveSelectedProperties(comparePropertyIds, _to_consumable_array(previousPreservedProperties).concat(_to_consumable_array(previousSearchResults)));
    return _object_spread_props(_object_spread({}, state), {
        preservedProperties: preservedProperties,
        searchResultsProperties: searchResultsProperties,
        comparePropertyIds: reselectPropertyIds ? selectPropertyIds(reselectPropertyIds, _to_consumable_array(preservedProperties).concat(_to_consumable_array(searchResultsProperties))) : comparePropertyIds
    });
};
var addCompareProperty = function(state, propertyId) {
    return _object_spread_props(_object_spread({}, state), {
        comparePropertyIds: _to_consumable_array(state.comparePropertyIds).concat([
            propertyId
        ]),
        reselectPropertyIds: initialState.reselectPropertyIds
    });
};
var removeCompareProperty = function(state, cardId) {
    var _state_deepLinkDialogPropertyIds;
    var propertyId = getPropertyIdFromCardId(cardId);
    var comparePropertyIds = state.comparePropertyIds.filter(function(id) {
        return getPropertyIdFromCardId(id) !== propertyId;
    });
    var _state_deepLinkDialogPropertyIds_filter;
    var deepLinkDialogPropertyIds = (_state_deepLinkDialogPropertyIds_filter = (_state_deepLinkDialogPropertyIds = state.deepLinkDialogPropertyIds) === null || _state_deepLinkDialogPropertyIds === void 0 ? void 0 : _state_deepLinkDialogPropertyIds.filter(function(id) {
        return getPropertyIdFromCardId(id) !== propertyId;
    })) !== null && _state_deepLinkDialogPropertyIds_filter !== void 0 ? _state_deepLinkDialogPropertyIds_filter : initialState.deepLinkDialogPropertyIds;
    var isDialogOpen = state.isDialogOpen && (deepLinkDialogPropertyIds || comparePropertyIds).length > 1;
    return _object_spread_props(_object_spread({}, state), {
        comparePropertyIds: comparePropertyIds,
        isDialogOpen: isDialogOpen,
        reselectPropertyIds: initialState.reselectPropertyIds,
        deepLinkDialogPropertyIds: isDialogOpen ? deepLinkDialogPropertyIds : initialState.deepLinkDialogPropertyIds
    });
};
var openDialog = function(state) {
    return _object_spread_props(_object_spread({}, state), {
        isDialogOpen: true
    });
};
var closeDialog = function(state) {
    return _object_spread_props(_object_spread({}, state), {
        isDialogOpen: false,
        deepLinkDialogPropertyIds: initialState.deepLinkDialogPropertyIds
    });
};
var enable = function(state) {
    localStorage.setItem("toggleState", String(true));
    return _object_spread_props(_object_spread({}, state), {
        enabled: true
    });
};
var disable = function(state) {
    localStorage.setItem("toggleState", String(false));
    return _object_spread_props(_object_spread({}, state), {
        enabled: false
    });
};
var resetSelection = function(state) {
    return _object_spread_props(_object_spread({}, state), {
        comparePropertyIds: initialState.comparePropertyIds,
        preservedProperties: initialState.preservedProperties,
        reselectPropertyIds: initialState.reselectPropertyIds
    });
};
var setBottomSheetHeight = function(state, bottomSheetHeight) {
    return _object_spread_props(_object_spread({}, state), {
        bottomSheetHeight: bottomSheetHeight
    });
};
var lodgingCompareReducers = {
    setProperties: setProperties,
    addCompareProperty: addCompareProperty,
    removeCompareProperty: removeCompareProperty,
    openDialog: openDialog,
    closeDialog: closeDialog,
    enable: enable,
    disable: disable,
    resetSelection: resetSelection,
    setBottomSheetHeight: setBottomSheetHeight
};
var noop = function() {
    return void 0;
};
var defaultDispatchers = {
    setProperties: noop,
    addCompareProperty: noop,
    removeCompareProperty: noop,
    openDialog: noop,
    closeDialog: noop,
    enable: noop,
    disable: noop,
    resetSelection: noop,
    setBottomSheetHeight: noop
};
var LodgingCompareContext = createContext2([
    initialState,
    defaultDispatchers
]);
var Provider2 = LodgingCompareContext.Provider;
var initializeState = function(location) {
    var params = new URLSearchParams(location.search);
    var propertiesFromSearchParams = parsePropertyIds(params.get(COMPARE_PROPERTY_IDS_QUERY_PARAMETER));
    var reselectPropertyIds = propertiesFromSearchParams.length ? propertiesFromSearchParams : initialState.reselectPropertyIds;
    return _object_spread_props(_object_spread({}, initialState), {
        enabled: typeof localStorage === "undefined" ? initialState.enabled : Boolean(localStorage.getItem("toggleState")),
        reselectPropertyIds: reselectPropertyIds,
        deepLinkDialogPropertyIds: params.get(DIALOG_KEY) === DIALOG_ID && reselectPropertyIds ? reselectPropertyIds : initialState.deepLinkDialogPropertyIds
    });
};
var LodgingCompareProvider = function(param) {
    var children = param.children;
    var location = useLocation();
    var _useReducers = _sliced_to_array(useReducers(location, initializeState, lodgingCompareReducers), 2), state = _useReducers[0], dispatchers = _useReducers[1];
    var value = useMemo3(function() {
        return [
            state,
            dispatchers
        ];
    }, [
        state,
        dispatchers
    ]);
    return /* @__PURE__ */ React2.createElement(Provider2, {
        value: value
    }, children);
};
var useLodgingCompare = function() {
    return useContext(LodgingCompareContext);
};
export { CompareAdaptExContext, CompareAdaptExProvider, LodgingCompareContext, LodgingCompareProvider, SHOW_PROMPT, SHOW_PROMPT_NO, SHOW_PROMPT_YES, TICK_BOX_VISIBILITY, TICK_BOX_VISIBILITY_FALSE, TICK_BOX_VISIBILITY_TRUE, TOGGLE_PLACEMENT, TOGGLE_PLACEMENT_FILTERS_SHEET, TOGGLE_PLACEMENT_NONE, TOGGLE_PLACEMENT_SRP, defaultState, useLodgingCompare };
//# sourceMappingURL=index.js.map